import { useState, useContext, useEffect } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { FormGroup, FormControlLabel, Checkbox } from "@mui/material";

import { DiscoveryContext } from "./discovery-context";

export default function ProductVariant({
  variants,
  triggerId = "basic-menu",
  children,
  index,
  editable = true,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeVariants, setActiveVariants] = useState(variants);

  const discoveryCtx = useContext(DiscoveryContext);

  useEffect(() => {
    setActiveVariants(variants);
  }, [variants]);

  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
    if(!editable) return;
    const updatedCompetitors = [...discoveryCtx.competitors];
    updatedCompetitors[index].variants = activeVariants;
    discoveryCtx.updatedCompetitors(updatedCompetitors);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleChange = (e) => {
    if (!e.target.id) return;
    setActiveVariants((prevVariants) => {
      return prevVariants.map((variant) => {
        return {
          ...variant,
          active:
            variant.id === e.target.id ? e.target.checked : variant.active,
        };
      });
    });
  };

  return (
    <div>
      <span
        id="basic-button"
        aria-controls={open ? triggerId : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        {children}
      </span>
      <Menu
        aria-modal="true"
        id={triggerId}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <FormGroup>
          {activeVariants.map((variant) => {
            return (
              <MenuItem dense key={variant.id}>
                <FormControlLabel
                  control={
                    <>
                      {editable ? (
                        <Checkbox
                          size="small"
                          id={variant.id}
                          sx={{ p: 0, m: 0, fontSize: 5 }}
                          checked={variant?.active || false}
                          onChange={handleChange}
                        />
                      ) : null}
                    </>
                  }
                  label={variant.name}
                  sx={{
                    "& .MuiTypography-root": {
                      fontSize: "0.8rem",
                      lineHeight: 1,
                      paddingLeft: "0.4rem",
                    },
                  }}
                />
              </MenuItem>
            );
          })}
        </FormGroup>
      </Menu>
    </div>
  );
}
